import {Route, Routes} from 'react-router-dom';
import AdministrationDetails from "./pages/AdministrationDetails";
import CalendarDetails from "./pages/CalendarDetails";
import CitizenReporterDetails from "./pages/CitizenReporterDetails";
import CivilServiceDetails from './pages/CivilServiceDetails';
import CodeDetails from "./pages/CodeDetails";
import ContactDetails from "./pages/ContactDetails";
import CouncilDetails from "./pages/CouncilDetails";
import DocsDetails from "./pages/DocsDetails";
import EACDetails from "./pages/EACDetails";
import EmploymentDetails from "./pages/EmploymentDetails";
import FormsDetails from "./pages/FormsPage/FormsDetails";
import HowDoIDetails from "./pages/HowDoIDetails";
import JSBBCDetails from "./pages/JSBBCDetails";
import LibraryBoardDetails from './pages/LibraryBoardDetails';
import MayorDetails from "./pages/MayorDetails";
import MEDCDetails from './pages/MEDCDetails';
import MMADetails from "./pages/MMADetails";
import NotFoundDetails from './pages/NotFoundDetails';
import PlanningDetails from "./pages/PlanningDetails";
import PoliceGeneralDetails from "./pages/PoliceGeneralDetails";
import PoliceDocumentsDetails from "./pages/PoliceDocumentsDetails";
import PolicePersonnelDetails from "./pages/PolicePersonnelDetails";
import PoliceResourcesDetails from "./pages/PoliceResourcesDetails";
import PoliceStatisticsDetails from "./pages/PoliceStatisticsDetails";
import PrivacyDetails from "./pages/PrivacyDetails";
import PublicWorksDetails from "./pages/PublicWorksDetails";
import ResourcesDetails from "./pages/ResourcesDetails";
import ResRentalProgramDetails from './pages/ResRentalProgramDetails';
import RTKDetails from "./pages/RTKDetails";
import SanitationDetails from "./pages/SanitationDetails";
import SearchDetails from "./pages/SearchDetails";
import StormwaterDetails from "./pages/StormwaterDetails";
import TaxDetails from "./pages/TaxDetails";
import TourismDetails from "./pages/TourismDetails";
import VPRBDetails from "./pages/VPRBDetails";
import WaterSewerDetails from "./pages/WaterSewerDetails";
import ZHBDetails from "./pages/ZHBDetails";
import PoliceJobOpenings from './pages/PoliceJobOpenings';

export default function LayoutAllPages() {
  return (
    <div>
      <main>
        <Routes>
          <Route path="/administration" element={<AdministrationDetails />} />
          <Route path="/calendar/index.html" element={<CalendarDetails />} />
          <Route path="/calendar" element={<CalendarDetails />} />
          <Route path="/citizenreporter" element={<CitizenReporterDetails />} />
          <Route path="/civilservice" element={<CivilServiceDetails />} />
          <Route path="/code" element={<CodeDetails />} />
          <Route path="/contact" element={<ContactDetails />} />
          <Route path="/council" element={<CouncilDetails />} />
          <Route path="/docs" element={<DocsDetails />} />
          <Route path="/eac" element={<EACDetails />} />
          <Route path="/employment" element={<EmploymentDetails />} />
          <Route path="/forms" element={<FormsDetails />} />
          <Route path="/howdoi" element={<HowDoIDetails />} />
          <Route path="/jsbbc" element={<JSBBCDetails />} />
          <Route path="/libraryboard" element={<LibraryBoardDetails />} />
          <Route path="/mayor" element={<MayorDetails />} />
          <Route path="/medc" element={<MEDCDetails />} />
          <Route path="/mma" element={<MMADetails />} />
          <Route path="/planning" element={<PlanningDetails />} />          
          <Route path="/police" element={<PoliceGeneralDetails />} />
          <Route path="/police/documents" element={<PoliceDocumentsDetails />}/>
          <Route path="/police/jobs" element={<PoliceJobOpenings />}/>
          <Route path="/police/personnel" element={<PolicePersonnelDetails />}/>
          <Route path="/police/resources" element={<PoliceResourcesDetails />}/>
          <Route path="/police/statistics" element={<PoliceStatisticsDetails />}/>
          <Route path="/privacy" element={<PrivacyDetails />} />
          <Route path="/publicworks" element={<PublicWorksDetails />} />
          <Route path="/resources" element={<ResourcesDetails />} />
          <Route path="/rental" element={<ResRentalProgramDetails />} />
          <Route path="/rtk" element={<RTKDetails />} />
          <Route path="/sanitation" element={<SanitationDetails />} />
          <Route path="/search" element={<SearchDetails />} />
          <Route path="/stormwater" element={<StormwaterDetails />} />
          <Route path="/tax" element={<TaxDetails />} />
          <Route path="/tourism" element={<TourismDetails />} />          
          <Route path="/vprb" element={<VPRBDetails />} />
          <Route path="/water-sewer" element={<WaterSewerDetails />} />
          <Route path="/zoning" element={<ZHBDetails />} />
          <Route path="*" element={<NotFoundDetails />} />
          
        </Routes>
      </main>
    </div>
  );
}
